<template>
  <div class="contactUs">
    <div class="head">
      <H3>{{title}}</H3>
    </div>
    <ul class="content">
      <li v-for="(item, i) in contactWays" :key="i">
        <img :src="item.url" alt="">
        <span>{{item.title}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contactUs',
  data () {
    return {
      title: '联系我们',
      contactWays: [
        {
          title: '客服电话:027-87531698',
          url: './static/img/call.png'
        },
        {
          title: '客服邮箱：1258341428@qq.com',
          url: './static/img/email.png'
        },
        {
          title: '微信客服：cdkj_hdzs',
          url: './static/img/wx.png'
        },
        {
          title: 'QQ客服：1258341428',
          url: './static/img/qq.png'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
  .contactUs{
    .head{
      height: 90px;
      border-bottom: 1px solid #dedede;
      h3{
        font-size: 24px;
        font-weight: bold;
        line-height: 90px;
        padding-left: 20px;
        color: #5E5E5E;
      }
    }
    .content{
      li{
        font-size: 20px;
        line-height: 70px;
        width: 500px;
        margin: 40px auto;
        color: #010101;
        img{
          vertical-align: middle;
          width: 70px;
          margin-right: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/contactUs.vue